import BlankLayout from '@/layouts/BlankLayout.vue'

export default [
  {
    path: '',
    redirect: { name: 'LoginView' },
  },
]
